import { companyLicenseStateApi, nmlsLicenseApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const COMPANY_LICENSED_STATES_ACTION_TYPE = createNamedActions('companyLicensedStates', {
  GET_STATES: 'GET_STATES',
  ADD_STATE: 'ADD_STATE',
  EDIT_STATE: 'EDIT_STATE',
  DELETE_STATE: 'DELETE_STATE',
  GET_NMLS_STATES: 'GET_NMLS_STATES',
  SYNC_NMLS_STATES: 'SYNC_NMLS_STATES',
});

const licensedStates = new schema.Entity('data', {}, { idAttribute: license => license.id });

export const getCompanyLicensedStatesAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await companyLicenseStateApi.getCompanyLicenseState(params);

  return dispatch({
    type: COMPANY_LICENSED_STATES_ACTION_TYPE.GET_STATES,
    payload: normalize(data, [licensedStates]).entities.data,
  });
});

export const createCompanyLicensedStateAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await companyLicenseStateApi.createCompanyLicenseState(params);

  return dispatch({
    type: COMPANY_LICENSED_STATES_ACTION_TYPE.ADD_STATE,
    payload: data,
  });
});

export const editCompanyLicensedStateAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await companyLicenseStateApi.editCompanyLicenseState(params);

  return dispatch({
    type: COMPANY_LICENSED_STATES_ACTION_TYPE.EDIT_STATE,
    payload: data,
  });
});

export const deleteCompanyLicensedStateAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await companyLicenseStateApi.deleteCompanyLicenseState(params);

  return dispatch({
    type: COMPANY_LICENSED_STATES_ACTION_TYPE.DELETE_STATE,
    payload: data,
    meta: params,
  });
});

export const getCompanyNmlsLicensesAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await nmlsLicenseApi.getCompanyNmlsLicenses(params);

  return dispatch({
    type: COMPANY_LICENSED_STATES_ACTION_TYPE.GET_NMLS_STATES,
    payload: data,
  });
});

export const syncCompanyLicensedStatesFromNmlsAction = catchAsyncActionError(
  params => async dispatch => {
    await nmlsLicenseApi.syncCompanyLicensesFromNmls(params);

    dispatch({ type: COMPANY_LICENSED_STATES_ACTION_TYPE.SYNC_NMLS_STATES });

    return dispatch(getCompanyLicensedStatesAction(params));
  },
);
